/* eslint-disable global-require */
module.exports = [...require('./WarningModale/i18n'), ...require('./PurchaseNotAvailable/i18n')];
